const isCorrectPhoneNumber = (value: string): boolean =>
  /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){11}(\s*)?$/.test(value);

export const authBottomSheetLib = {
  isCorrectPhoneNumber,
};
